import * as React from 'react'

import {Button, Form, Input, message} from 'antd';
import {FormComponentProps} from "antd/lib/form";
import {observer} from "mobx-react";
import {ViewBaseComponent} from "../../../src/views/ViewComponentBase";
import commonStyles from '../../../src/styles/common.scss';
import {BASE_PATH} from "../../../src/swagger";
import appStyles from '../../assets/css/app.scss';
import {action, observable, runInAction} from "mobx";
import {fetchWithCsrf} from "../../../src/utils/csrf";
import {BaseValidations} from "../../../src/utils/form/validate/BaseValidations";
import KixGbcMemberSimpleLayout from "../../layouts/KixGbcMemberSimpleLayout/KixGbcMemberSimpleLayout";
import {globalStore} from "../../../src/store/GlobalStore";

const FormItem = Form.Item;

@observer
class PasswordReset extends ViewBaseComponent<{} & FormComponentProps, {}> {
  formUtils = this.props.form;

  @observable
  sended = false;

  componentWillMount() {
  }

  componentWillUnmount() {
  }

  @action
  handleSubmit = () => {
    this.formUtils.validateFields((err, _values: any) => {
      if (!err) {
        let bodyObj = {
          email: this.formUtils.getFieldValue("email"),
          url: location.href,
        };
        const method = "POST";
        const body = JSON.stringify(bodyObj);
        const headers = {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        };
        fetchWithCsrf(BASE_PATH + "/kix_gbc/password_reset", {
          method,
          headers,
          body
        }).then(async (res: any) => {
          // 500エラーチェック
          if (res.status === 500) {
            globalStore.setServerError(true);
            return;
          }

          let json = await res.json();
          runInAction(() => {
            if (json.result.code == 1) {
              this.sended = true;
            } else {
              message.error(json.result.message);
            }
          });
        }).catch(() => {
          message.error("通信に失敗しました。もう一度お試し下さい。");
        });
      }
    });
  };

  render() {
    const {getFieldDecorator} = this.props.form;

    return (
      <>
        <KixGbcMemberSimpleLayout notLogout={true}>
        <h2 className={appStyles.h2blue} style={{marginTop: "2em", marginBottom: "2em"}}>パスワード再設定</h2>

        {!this.sended ?
          <>
            <p style={{color: "white"}}>ご登録のメールアドレスを入力して
              “送信”ボタンをクリックしてください。
            </p>

            <span className={appStyles.h3White} style={{fontSize: "1em"}}>メールアドレス</span>
            <FormItem>
              {getFieldDecorator('email', {
                validateTrigger: "onBlur",
                rules: [
                  BaseValidations.required,
                  BaseValidations.email,
                ],
              })(
                <Input size="large"
                       placeholder="メールアドレス"/>
              )}
            </FormItem>

            <div className={commonStyles.fCenter + " " + commonStyles.mt30}>
              <FormItem>
                <Button style={{padding: "0.5em 6em 0.5em 6em", margin: "1em 0 1em 0"}} type="primary"
                        size="large" className={appStyles.buttonBlue}
                        onClick={this.handleSubmit}
                >
                  送信
                </Button>
              </FormItem>
            </div>
          </> : <>
            <p style={{color: "white", fontWeight:"bold"}}>
              送信完了しました。
            </p>
            <p style={{color: "white"}}>
              ご登録のメールアドレス宛てにパスワード再設定のURLを
              送信しました。
            </p>

          </>
        }
      </KixGbcMemberSimpleLayout>
      </>
    );
  }
}

export default Form.create()(PasswordReset)

